export default __webpack_public_path__ + "static/media/aviator-game.a3aff570.png";